// extracted by mini-css-extract-plugin
export default {"bar":"styles__bar--XQ5NR","rounded":"styles__rounded--fVToo","bar-inner":"styles__bar-inner--PlI47","pinstripe":"styles__pinstripe--fK+D9"};